<template>
    <div id="employeeConfig" style="height:100%;">

        <el-row>
            <el-col :span="24">
                <el-collapse v-model="activeName" style="margin-bottom:15px;">
                    <el-collapse-item title="操作面板" name="1">
                        <div class="t-op__container">
                            <div class="t-op__item">
                                <el-button type="primary" icon="el-icon-circle-plus" @click="handleAdd">添加</el-button>
                            </div>
                            <div class="t-op__item">
                                <el-input placeholder="请输入级别名称" v-model="search" class="input-with-select">
                                    <el-button slot="append" icon="el-icon-search" @click="loadData"></el-button>
                                </el-input>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24">
                <el-table
                        v-loading="loading"
                        :data="tableData"
                        width="100%"
                        :height="tableHeight"
                        stripe>
                    <el-table-column
                            width="100"
                            type="index"
                            label="序号">
                    </el-table-column>
                    <el-table-column
                            label="级别"
                            prop="level">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="平均薪资"
                            prop="salary"
                            :formatter="fmtMoney">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            label="均摊"
                            prop="avgShare"
                            :formatter="fmtMoney">
                    </el-table-column>
                    <el-table-column
                            label="利用率"
                            prop="convertRate"
                            :formatter="formatTooltip">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="人天成本"
                            prop="dayCost"
                            :formatter="fmtMoney">
                    </el-table-column>
                    <el-table-column
                            label="创建人"
                            prop="createBy"
                            :formatter="fmtUserId">
                    </el-table-column>
                    <el-table-column
                            width="180"
                            label="创建时间"
                            prop="createTime">
                    </el-table-column>
                    <el-table-column
                            label="修改人"
                            prop="modifyBy"
                            :formatter="fmtUserId">
                    </el-table-column>
                    <el-table-column
                            label="修改时间"
                            width="180"
                            prop="modifyTime">
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">修改
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :hide-on-single-page="value"
                        style="padding:10px 0px;"
                        :page-size="pageSize"
                        :total="total"
                        :current-page="pageIndex"
                        @current-change="onCurrentChange">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="editItem.title" :width="editItem.width" :visible.sync="editItem.visible">

            <el-form :model="editItem.data">
                <el-form-item label="级别" label-width="150px">
                    <el-input v-model="editItem.data.level" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="利用率" label-width="150px">
                    <el-input type="number" v-model="editItem.data.convertRate" autocomplete="off">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="平均薪资" label-width="150px">
                    <el-input type="number" v-model="editItem.data.salary" autocomplete="off">
                        <template slot="append">￥</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="均摊" label-width="150px">
                    <el-input type="number" v-model="editItem.data.avgShare" autocomplete="off">
                        <template slot="append">￥</template>
                    </el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="editItem.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {requestELcfgList, requestELcfgAdd} from '@/api/api'

    export default {
        name: "EmployeeLevelConfig",
        data() {
            return {
                tableHeight: window.innerHeight * 0.70,
                activeName: ['1'],
                tableData: [],
                search: '',
                value: true,
                pageIndex: 1,
                pageSize: 20,
                total: 0,
                editItem: {
                    width: '60%',
                    visible: false,
                    title: '员工级别配置信息',
                    data: {
                        id: 0,
                        convertRate: 0,
                        level: '',
                        salary: 0,
                        avgShare: 0,
                        description: ''
                    },
                    isAdd: false,
                    filter: true,
                    userList: [],
                },
                loading:false
            }
        },
        methods: {
            fmtMoney(row, column) {
                if (column.property === 'avgShare') {
                    return '￥' + row.avgShare
                }
                if (column.property === 'dayCost') {
                    return '￥' + row.dayCost
                }
                if (column.property === 'salary') {
                    return '￥' + row.salary
                }
            },
            formatTooltip(row, column) {
                return (row.convertRate * 100) + "%"
            },
            fmtDayCost(row, column) {
                return '￥' + row.dayCost
            },
            fmtUserId(row, column) {
                let user = this.editItem.userList.find(v => v.id == row.createBy || v.id == row.modifyBy)
                if (user) {
                    return user.name
                }
                return ''
            },
            handleAdd() {
                this.editItem.data = {}
                this.editItem.title = '添加级别配置'
                this.editItem.visible = true
                this.editItem.isAdd = true
            },
            handleEdit(index, row) {
                debugger
                console.log(index, row);
                this.editItem.title = '编辑级别配置'
                this.editItem.visible = true
                let tt = JSON.parse(JSON.stringify(row))
                tt.convertRate = tt.convertRate * 100
                this.editItem.data = tt
                this.editItem.isAdd = false
            },
            loadData() {
                this.loading = true
                this.$store.dispatch("employee/getLevelConfigWithPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageIndex,
                    keyWord: this.search
                }).then(response => {
                    this.loading = false
                    this.tableData = response.data.data
                    this.total = response.data.total
                })
            },
            buildSubmitData() {
                /*做深拷贝处理，防止浅拷贝会影响界面已展示的数据*/
                let data = JSON.parse(JSON.stringify(this.editItem.data))
                data.convertRate = this.editItem.data.convertRate / 100
                return {data: data}
            },
            addLevelConfig() {
                this.$store.dispatch("employee/createLevelConfig", this.buildSubmitData())
                    .then(response => {
                        this.$message({
                            message: response.data.message,
                            type: 'success'
                        })
                        this.editItem.visible = false
                        this.editItem.data = {}
                        this.loadData()
                    })
            },
            editLevelConfig() {
                this.$store.dispatch("employee/saveLevelConfig", this.buildSubmitData())
                    .then(response => {
                        this.$message({
                            message: response.data.message,
                            type: 'success'
                        })
                        this.editItem.visible = false
                        this.editItem.data = {}
                        this.loadData()
                    })
            },
            onCurrentChange(page) {
                this.pageIndex = page
                this.loadData()
            },
            confirm() {
                if (this.editItem.isAdd) {
                    this.addLevelConfig()
                } else {
                    this.editLevelConfig()
                }
            },
            loadUserList() {
                this.$store.dispatch("employee/getAllUsers")
                    .then(response => {
                        if (response && response.data) {
                            if (response.data.data.length == 0) {
                                this.$message({
                                    message: '没有获取到用户数据',
                                    type: 'error'
                                })
                            }
                            this.editItem.userList = response.data.data
                        }
                    });
            },
        },
        created() {
            this.loadUserList()
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// employeeLevelConfig.vue?3e2661f9